export default __webpack_public_path__ + "static/media/logout.e62c222f.svg";